'use strict';

angular.module('myConsultApp').factory('IdentityService', function ($resource, ENV, Session) {
  var identityService = {};

  var user = '';

  var selectUserPets = null;

  var selectedUserRoute = null;

  var recentCreatedPetId = null;

  identityService.getUser = function (id) {
    var user = $resource(
      ENV.apiEndpoint + '/2.0/users/:id/',
      { id: id },
      { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
    );

    return user.get().$promise.then(function (response) {
      return response.users;
    });
  };


  identityService.storeUser = function (uservalue) {
    user = uservalue;
    return user;
  };

  identityService.getStoredUser = function () {
    return user;
  };

  identityService.storeSelectUserPets = function (info, routepath) {
    selectedUserRoute = routepath;
    selectUserPets = info;
    return selectUserPets;
  };

  identityService.getstoreSelectUserPets = function () {
    return selectUserPets;
  };

  identityService.getSelectedUsersPath = function () {
    return selectedUserRoute;
  };

  identityService.setRecentCreatedPetId = function (petid) {
    recentCreatedPetId = petid;
    return recentCreatedPetId;
  };

  identityService.getRecentCreatedPetId = function () {
    return recentCreatedPetId;
  };

  return identityService;
});
